<template>
  <div>
    <search @submit="submitSearch" ref="searchForm" />

    <div class="custom-table-operation-buttons">
      <a-button type="primary" @click="showNewModal">新增</a-button>
    </div>

    <a-table
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="id"
      @change="fetchData"
    >
      <div slot="effective" slot-scope="effective, record">
        <a-switch
          :checked="effective"
          :loading="editingEffectiveId === record.id"
          @change="(checked) => changeEffective(checked, record)"
        />
      </div>
      <span slot="actions" slot-scope="text, record">
        <a-space>
          <a @click="showEditModal(record)">编辑</a>
          <a @click="deleteColumn(record.id)" class="custom-delete" v-if="!record.is_default">删除</a>
        </a-space>
      </span>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <!-- 新增模态框 -->
    <new
      v-if="isShowNewModal"
      :visible.sync="isShowNewModal"
      @completed="fetchData"
    />

    <!-- 编辑模态框 -->
    <edit
      v-if="isShowEditModal"
      :visible.sync="isShowEditModal"
      :record="editingRecord"
      @completed="fetchData"
    />

  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import Search from '@/views/order_service_nodes/Search'
import {
  deleteOrderServiceNode,
  findOrderServiceNodes,
  updateOrderServiceNodeEffective
} from '@/api/order_service_node'

export default {
  name: 'OrderServiceNodeList',
  components: {
    Pagination,
    Search,
    New: () => import('@/views/order_service_nodes/New'),
    Edit: () => import('@/views/order_service_nodes/Edit'),
  },
  data() {
    return {
      query: {},
      data: [],
      loading: true,
      isShowNewModal: false, // 是否显示新增表单弹窗
      isShowEditModal: false, // 是否显示编辑表单弹窗
      editingEffectiveId: 0, // 正在修改有效性的记录id
      editingRecord: {}, // 正在编辑的记录id
      pagination: {
        total_count: 0
      },
      isShowSortModal: false,
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    columns() {
      return [
        {
          title: '节点名称',
          dataIndex: 'name',
          width: 150
        },
        {
          title: '节点说明',
          width: 200,
          dataIndex: 'description',
          scopedSlots: { customRender: 'description' }
        },
        {
          title: '状态',
          width: 100,
          dataIndex: 'effective',
          scopedSlots: { customRender: 'effective' }
        },

        {
          title: '操作',
          width: 100,
          dataIndex: 'actions',
          scopedSlots: { customRender: 'actions' }
        }
      ]
    }
  },
  methods: {
    showNewModal() {
      this.isShowNewModal = true
    },

    showEditModal(record) {
      this.editingRecord = record
      this.isShowEditModal = true
    },

    submitSearch(search) {
      // 赋值搜索条件，保留 per_page
      this.query = Object.assign({},
        this.$options.data().query,
        search)
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findOrderServiceNodes(this.query).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    },

    changeEffective(checked, record) {
      const vm = this
      const effective = checked

      this.$confirm({
        title: effective ? '确定启用节点吗？' : '确定禁用节点吗？禁用后不会影响已经使用此节点的确认单、理事表！确认理事工作时无法看到此节点！',
        content: '',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          vm.editingEffectiveId = record.id
          updateOrderServiceNodeEffective(record.id, { effective: effective })
              .then((res) => {
                vm.editingEffectiveId = 0
                if (res.code === 0) {
                  record.effective = checked
                  vm.fetchData()
                }
              })
              .catch(() => {
                vm.editingEffectiveId = 0
              })
        }
      })
    },

    deleteColumn(recordId) {
      const thisForm = this
      this.$confirm({
        title: '确定进行删除吗？删除后无法恢复',
        content: '',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          deleteOrderServiceNode(recordId).then(() => {
            thisForm.fetchData()
          })
        }
      })
    }
  }
}
</script>
